import { useEffect, useState, useRef } from "react";
import '../assets/css/CustomUtility.css'; // This is having invalid feedback and Datepicker related css
import '../assets/css/feather.css';
import '../assets/css/CG.css';
import '../assets/css/Login.css'
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';
import { useLogoutContent } from "../contexts/LogoutContentContext";   

const SSOExternalLogout = () => {
    const ref = useRef(null);

    // Set External Logout Message
    const [externalLogoutMsg, setExternalLogoutMsg] = useState([]);
    const {logoutContent} = useLogoutContent();// This is custom hook
    
    useEffect(() => {
        loadStyle(); // Load carrier specific styles and images
        if (logoutContent?.SSOExternal) {
            setExternalLogoutMsg(logoutContent.SSOExternal);
        }
    }, [logoutContent]);

    // Clear cookie and local storage on component mount
    useEffect(() => {
        clearAllCookies(); // Clear all cookies
        localStorage.clear(); // Clear local storage
    }, []);

    //Focus on main element for accessibility (st48236 - 508 compliance)
    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
        }
    }, []);

    const isConnectiCareCarrier = Cookies.get('isConnectiCareCarrier') || 'false';
    const connectiCareCarrier = Cookies.get('connectiCareCarrier') || null;
    const excludeCookies = ['lang', 'owningCarrier', 'portal_lang'];
    if(isConnectiCareCarrier === 'true' && connectiCareCarrier !== null){
        excludeCookies.push('isConnectiCareCarrier', 'connectiCareCarrier');
    }

    const clearAllCookies = () => {
        const allCookies = Cookies.get(); // Get all cookies as an object
        const cookieOptions = getCookieOptions(); // Get environment-aware cookie options
        Object.keys(allCookies).forEach(cookieName => {
            if(!excludeCookies.includes(cookieName)) { // Exclude specific cookies
                Cookies.remove(cookieName, { ...cookieOptions, path: '/' });
            }
        });
    }

    let actualCarrier = Cookies.get('owningCarrier');
    if(isConnectiCareCarrier === 'true' && connectiCareCarrier === process.env.REACT_APP_CONNECTICARE_CARRIER_CODE){
        actualCarrier = connectiCareCarrier;
    }

    // Load carrier logo and css dynamically based on owning carrier
    const [CarrierLogo, setCarrierLogo] = useState(null);
    const [LogoutImg, setLogoutImg] = useState(null);

    const loadStyle = async () => {
        import('../assets/images/carriers-logo/'+actualCarrier+'-sml.svg').then((image) => {
            setCarrierLogo(image.default);
        }).catch(() => {
            setCarrierLogo(null);
        });
        
        //Set Default image if specific carrier image not found
        import('../assets/images/Illustrations/Logout-'+actualCarrier+'.svg').then((image) => {
            setLogoutImg(image.default);
        }).catch(() => {
            import('../assets/images/Illustrations/Logout.svg').then((image) => {
                setLogoutImg(image.default);
            });
        });
        await import('../assets/css/'+actualCarrier+'.css');
    };

    return (
        <div>
            <section class="min-h-100 d-flex justify-content-center">
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        <div class="col-12 col-xxl-11 px-0">
                            <div style={{background:'#fff'}} class="border-light-subtle mb-0">
                                <div class="row g-0 shadow-lg">
                                    <div class="col-12 col-md-6 overlay-sl text-center pt-xl-3 p-3 
                                    p-sm-0 p-md-0 p-xl-0">
                                        <img src={LogoutImg} alt="Payment-mobile" class="mw-90 mt-5 pb-4" />
                                    </div>
                                    <div class="col-12 col-md-6 d-flex mt-4 justify-content-center
                                    align-items-center">
                                        <div class="col-12 col-lg-11 col-xl-10">
                                            <div class="card-body p-3 p-md-4 p-xl-3" tabIndex="-1"
            ref={ref} style={{ outline: 'none' }} aria-live="assertive" role="status">
                                                <div class="row">
                                                    <div class="col-12 d-flex">
                                                        <div class="col-6">
                                                            <img src={CarrierLogo} class="mb-2" width="120" alt="Carrier logo" />
                                                        </div>
                                                        <div class="col-6 text-end">                                           
                                                        </div>
                                                    </div>
                                                </div>
                                                <form class="needs-validation" novalidate>
                                                    <div class="row gy-3 overflow-hidden mt-0">
                                                        <div class="member-SLP mt-4">
                                                            <h3 class="text-left fw-semibold primary-color mb-3 pb-2">
                                                                {externalLogoutMsg?.ssoexternal_logout_message}
                                                            </h3>                                          
                                                        </div>                   
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           </section>
        </div>
    );
};

export default SSOExternalLogout;